import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import { BoardTemplate } from '../../mainApi';

type DeleteTemplateDialogProps = {
  template: BoardTemplate | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteTemplateDialog = ({
  template,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteTemplateDialogProps) => (
  <Dialog
    open={Boolean(template)}
    onClose={() => {
      if (!isDeleting) {
        onClose();
      }
    }}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle>Delete template</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete{' '}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {template?.name || 'Untitled template'}
        </Box>
        ?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isDeleting}>
        Cancel
      </Button>
      <Button color="error" variant="contained" onClick={onConfirm} disabled={isDeleting}>
        {isDeleting ? 'Deleting...' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);
